
import { Route, Routes, Navigate } from "react-router-dom";
import "./App.css";

import Home from "./pages/Home/Home";
import About from "./pages/About/About";
import Contact from "./pages/Contact/Contact";
import Tours from "./pages/Tours/Tours";
import TourDetails from "./pages/Tours/TourDetails";
import Booking from "./pages/Booking/Booking";
import Destinations from "./pages/Destinations/Destinations";
import PhotoGallery from "./pages/PhotoGallery/PhotoGallery";
import AdminMessages from "./pages/Admin/AdminDashboard";
import AdminLogin from "./pages/Admin/AdminLogin";
import AddTour from "./pages/Admin/AddTour";

import Header from "./components/Common/Header/Header";
import Footer from "./components/Common/Footer/Footer";
import ProtectedRoute from "./components/Auth/ProtectedRoute";
import EditTour from "./pages/Admin/EditTour";
import StateWiseTours from "./pages/Tours/StateWiseTours";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsAndConditions from "./pages/TermsAndConditions";
import Disclaimer from "./pages/Disclaimer";
import BlogDetails from "./pages/Blog/BlogDetails";
import AddBlog from "./pages/Blog/AddBlog";
import Blogs from "./pages/Blog/Blogs";
import EditBlog from "./pages/Blog/EditBlog";
import WhatsAppChat from "./components/Common/WhatsAppChat";

function App() {
  return (
    <div className="app-wrapper d-flex flex-column min-vh-100">
      <Header />
      <main className="flex-grow-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about-us" element={<About />} />
          <Route path="/contact-us" element={<Contact />} />
          <Route path="/tours" element={<Tours />} />
          <Route path="/tour-details/:id" element={<TourDetails />} />
          <Route path="/booking/:id" element={<Booking />} />
          <Route path="/destinations" element={<Destinations />} />
          <Route path="/gallery" element={<PhotoGallery />} />
          <Route path="/admin-login" element={<AdminLogin />} />
          <Route path="/admin/edit-tour/:id" element={<EditTour />} />
          <Route path="/state/:stateName" element={<StateWiseTours />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/blog/:id" element={<BlogDetails />} />
          <Route path="/booking" element={<Navigate to="/tours" />} />

          {/*  Protected Routes */}
          <Route
            path="/admin/add-blog"
            element={
              <ProtectedRoute>
                <AddBlog />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/edit-blog/:id"
            element={
              <ProtectedRoute>
                <EditBlog />
              </ProtectedRoute>
            }
          />


          <Route
            path="/admin-dashboard"
            element={
              <ProtectedRoute>
                <AdminMessages />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/add-tour"
            element={
              <ProtectedRoute>
                <AddTour />
              </ProtectedRoute>
            }
          />
        </Routes>
      </main>
      <Footer />
      <WhatsAppChat />

    </div>
  );
}

export default App;
